.isHidden:not(:focus, :active) {
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

@media (width <= 768px) {
  .isHidden__tabletMax:not(:focus, :active) {
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    opacity: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}

.hideFromScreenReader:not(:focus, :active) {
  display: none;
  visibility: hidden;
}
